/**
 * Custom Empty Component
 * Extends Ant Design Empty with custom styling
 */

import { Empty as AntEmpty, EmptyProps } from 'antd';
import classNames from 'classnames';
import './CustomEmpty.scss';

export interface CustomEmptyProps extends EmptyProps {
  /** Empty variant */
  variant?: 'default' | 'simple' | 'card';
}

/**
 * CustomEmpty Component
 */
export const CustomEmpty: React.FC<CustomEmptyProps> = ({
  variant = 'default',
  className,
  description = 'No data available',
  ...rest
}) => {
  const emptyClasses = classNames('custom-empty', `custom-empty--${variant}`, className);

  return <AntEmpty {...rest} description={description} className={emptyClasses} />;
};

export default CustomEmpty;

